import { client } from '@/client';

// 图表信息
export function getChartsData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/kop/zk/${clusterName}/overview`, others);
}

// 总览数据
export function getOverview(clusterName) {
  return client.get(`/api/metrics/kop/zookeeper/${clusterName}/overview`);
}

// 获取表格数据
export function getZookeeperList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/kop/zookeeper/${clusterName}/list`, others);
}

/** 单个server图表数据 */
export const getServerChart = (params) => {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/kop/zk/${clusterName}`, others);
};
